import './set-public-path'
import 'babel-polyfill'
import React from 'react'
import App from './App'
import ErrorView from './Error'
import { render } from 'react-dom'
import formatMessage from 'format-message'
import generateId from 'format-message-generate-id'
import lookupClosestLocale from 'lookup-closest-locale'
import { AVAILABLE_LOCALES } from './pdfjs/constants'
import ErrorBoundary from 'react-error-boundary'

const rawLocale =
  (window.DocViewer && window.DocViewer.sessionData && window.DocViewer.sessionData.locale) ||
  (window.navigator.languages && window.navigator.languages.length
    ? window.navigator.languages[0]
    : window.navigator.language) ||
  window.navigator.userLanguage ||
  'en'
const closestLocale = lookupClosestLocale(rawLocale.toLowerCase(), AVAILABLE_LOCALES)

// fall back to english if there is no function for resulting locale. DIG-1851
const locale = typeof AVAILABLE_LOCALES[closestLocale] === 'function' ? closestLocale : 'en'

const accessToken = window.DocViewer && window.DocViewer.accessToken

function logLocaleLoad(lang) {
  return (translations) => {
    console.info(`Locale: ${lang}`)
    return translations
  }
}

AVAILABLE_LOCALES[locale]()
  .then(logLocaleLoad(locale))
  .then((localeData) => {
    formatMessage.setup({
      locale: locale,
      missingTranslation: 'ignore',
      generateId: generateId.underscored_crc32,
      translations: { [locale]: localeData },
    })
    document.documentElement.setAttribute('lang', locale)

    const FallbackComponent = ({ componentStack, error }) => {
      console.error(error)
      return <ErrorView errorMessage={error.toString()} componentStack={componentStack} />
    }

    render(
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        <App accessToken={accessToken} locale={locale} />
      </ErrorBoundary>,
      document.getElementById('App'),
    )
  })
